var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page2"},[_c('div',{staticClass:"mk2"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"block mk1"},[_c('div',{staticClass:"table-block",attrs:{"id":"part1"}},[_c('Table',{staticClass:"table_right",attrs:{"border":"","columns":_vm.columns3,"data":_vm.list,"cellClassName":_vm.cellClassName2}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }